import { render, staticRenderFns } from "./TableInsurancesExpiring.vue?vue&type=template&id=58b42920&"
import script from "./TableInsurancesExpiring.vue?vue&type=script&lang=js&"
export * from "./TableInsurancesExpiring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports